import { motion } from "framer-motion";
import { REACTIONS } from "@/lib/bookDna";
import { useBookReactions } from "@/hooks/useReactions";

interface ReactionBarProps {
  bookId: string;
  variant?: "full" | "compact";
}

const ReactionBar = ({ bookId, variant = "full" }: ReactionBarProps) => {
  const { counts, mine, toggle } = useBookReactions(bookId);

  const list = variant === "compact"
    ? REACTIONS
        .map((r) => ({ ...r, count: counts[r.id] ?? 0 }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 3)
    : REACTIONS.map((r) => ({ ...r, count: counts[r.id] ?? 0 }));

  // top reaction highlight
  const top = [...REACTIONS]
    .map((r) => ({ ...r, count: counts[r.id] ?? 0 }))
    .sort((a, b) => b.count - a.count)[0];

  return (
    <div className={variant === "full" ? "space-y-3" : "space-y-1"}>
      {variant === "full" && top && top.count >= 5 && (
        <p className="text-sm text-primary font-semibold">
          {top.emoji} {top.count} readers are <span className="uppercase">{top.id}</span>
        </p>
      )}
      <div className={`flex flex-wrap gap-1.5 ${variant === "compact" ? "" : "gap-2"}`}>
        {list.map((r) => {
          const active = mine.has(r.id);
          return (
            <motion.button
              key={r.id}
              type="button"
              whileTap={{ scale: 0.92 }}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(r.id); }}
              className={`inline-flex items-center gap-1 rounded-full border text-xs font-semibold transition-colors ${
                variant === "compact" ? "px-2 py-0.5" : "px-3 py-1.5"
              } ${
                active
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-card border-border hover:border-primary/40 hover:bg-primary/5"
              }`}
              title={r.id}
            >
              <span>{r.emoji}</span>
              {variant === "full" && <span className="hidden sm:inline">{r.id}</span>}
              {r.count > 0 && <span className="opacity-80">{r.count}</span>}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default ReactionBar;
